/// <reference types="jquery" />

const coerceTypes : { [key : string] : any }
	= { true: true, false: false, null: null };

export default function deparam(params : string, coerce = false) {

	const obj : Record<string, any> = {};

	// If params is an empty string or otherwise falsy, return obj.
	if (!params) {
		return obj;
	}

	// Iterate over all name=value pairs.
	params.replace(/\+/g, ' ').split('&').forEach(v => {
		const param = v.split('=');
		let key = decodeURIComponent(param[0]);
		let val = null;
		let cur = obj;
		let i = 0;

		// If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
		// into its component parts.
		let keys = key.split('][');
		let keysLast = keys.length - 1;

		// If the first keys part contains [ and the last ends with ], then []
		// are correctly balanced.
		if (/\[/.test(keys[0]) && /\]$/.test(keys[keysLast])) {
			// Remove the trailing ] from the last keys part.
			keys[keysLast] = keys[keysLast].replace(/\]$/, '');

			// Split first keys part into two parts on the [ and add them back onto
			// the beginning of the keys array.
			const part = keys.shift();
			if (part !== undefined) {
				keys = part.split('[').concat(keys);
			}

			keysLast = keys.length - 1;
		} else {
			// Basic 'foo' style key.
			keysLast = 0;
		}

		// Are we dealing with a name=value pair, or just a name?
		if (param.length === 2) {
			val = decodeURIComponent(param[1]);

			// Coerce values.
			if (coerce) {
				val = val && !isNaN(val as any) && ((+val + '') === val) ? +val // Isa number
				: val === 'undefined'                       ? undefined         // Isa undefined
				: coerceTypes[val] !== undefined           ? coerceTypes[val]   // Isa true, false, null
				: val;                                                          // Isa string
			}

			if (keysLast) {
				// Complex key, build deep object structure based on a few rules:
				// * The 'cur' pointer starts at the object top-level.
				// * [] = array push (n is set to array length), [n] = array if n is
				//   numeric, otherwise object.
				// * If at the last keys part, set the value.
				// * For each keys part, if the current level is undefined create an
				//   object or array based on the type of the next keys part.
				// * Move the 'cur' pointer to the next level.
				// * Rinse & repeat.
				for (; i <= keysLast; i++) {
					key = keys[i] === '' ? cur.length : keys[i];
					if (i < keysLast) {
						// Patched by taagrmal: must check if property is ours
						// Otherwise we must not overwrite it by any means!
						if (Object.prototype.hasOwnProperty.call(cur, key) && cur[key]) {
							cur = cur[key]; // Re-use existing object
						} else {
							cur = cur[key] = keys[i + 1] && isNaN(keys[i + 1] as any) ? {} : [];
						}
					} else {
						cur[key] = val;
					}
				}

			} else {
				// Simple key, even simpler rules, since only scalars and shallow
				// arrays are allowed.

				if (Object.prototype.toString.call(obj[key]) === '[object Array]') {
					// Val is already an array, so push on the next value.
					obj[key].push(val);

				} else if (Object.prototype.hasOwnProperty.call(obj, key)) {
					// Val isn't an array, but since a second value has been specified,
					// convert val into an array.
					obj[key] = [obj[key], val];

				} else {
					// Val is a scalar.
					obj[key] = val;
				}
			}

		} else if (key) {
			// No value was defined, so set something meaningful.
			obj[key] = coerce ? undefined : '';
		}
	});

	return obj;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/vendor/jquery-deparam-patched.ts